import {LocationDesk} from './location-desk.model';

export class ControlDesk {

  internalId: string;
    name: string;
    type: string;
    active: boolean;
    turnPrefix: string;
    waitingAndAttendingTurns: number;
    lastCalledTurnAlias: string;
    lastCalledTurnNumber: string;
    private lastCalledTurnCustomerName: string;
    private lastDeliveredTurnAlias: string;
    private lastDeliveredTurnNumber: string;
    private nextAvailableTurnNumber: string;
    locations: LocationDesk[];
    constructor(internalId?: string,
                name?: string,
                type?: string,
                active?: boolean,
                turnPrefix?: string,
                waitingAndAttendingTurns?: number,
                lastCalledTurnAlias?: string,
                lastCalledTurnNumber?: string,
                lastCalledTurnCustomerName?: string,
                lastDeliveredTurnAlias?: string,
                lastDeliveredTurnNumber?: string,
                nextAvailableTurnNumber?: string,
                locations?: LocationDesk[]) {
                    this.internalId = internalId;
                    this.name = name;
                    this.type = type;
                    this.active = active;
                    this.turnPrefix = turnPrefix;
                    this.waitingAndAttendingTurns = waitingAndAttendingTurns;
                    this.lastCalledTurnAlias = lastCalledTurnAlias;
                    this.lastCalledTurnNumber = lastCalledTurnNumber;
                    this.lastCalledTurnCustomerName = lastCalledTurnCustomerName;
                    this.lastDeliveredTurnAlias = lastDeliveredTurnAlias;
                    this.lastDeliveredTurnNumber = lastDeliveredTurnNumber;
                    this.nextAvailableTurnNumber = nextAvailableTurnNumber;
                    this.locations = locations;
    }


  public get InternalId(): string {
    return this.internalId;
  }

  public set InternalId(value) {
    this.internalId = value;
  }

  public get Name(): string {
    return this.name;
  }

  public set Name(value: string) {
    this.name = value;
  }

  public get Type(): string {
    return this.type;
  }

  public set Type(value: string) {
    this.type = value;
  }

  public get Active(): boolean {
    return this.active;
  }

  public set Active(value: boolean) {
    this.active = value;
  }

  public get TurnPrefix(): string {
    return this.turnPrefix;
  }

  public set TurnPrefix(value: string) {
    this.turnPrefix = value;
  }

  public get WaitingAndAttendingTurns(): number {
    return this.waitingAndAttendingTurns;
  }

  public set WaitingAndAttendingTurns(value: number) {
    this.waitingAndAttendingTurns = value;
  }

  public get LastCalledTurnAlias(): string {
    return this.lastCalledTurnAlias;
  }

  public set LastCalledTurnAlias(value: string) {
    this.lastCalledTurnAlias = value;
  }

  public get LastCalledTurnNumber(): string {
    return this.lastCalledTurnNumber;
  }

  public set LastCalledTurnNumber(value: string) {
    this.lastCalledTurnNumber = value;
  }

  public get LastCalledTurnCustomerName(): string {
    return this.lastCalledTurnCustomerName;
  }

  public set LastCalledTurnCustomerName(value: string) {
    this.lastCalledTurnCustomerName = value;
  }

  public get LastDeliveredTurnAlias(): string {
    return this.lastDeliveredTurnAlias;
  }

  public set LastDeliveredTurnAlias(value: string) {
    this.lastDeliveredTurnAlias = value;
  }

  public get LastDeliveredTurnNumber(): string {
    return this.lastDeliveredTurnNumber;
  }

  public set LastDeliveredTurnNumber(value: string) {
    this.lastDeliveredTurnNumber = value;
  }

  public get NextAvailableTurnNumber(): string {
    return this.nextAvailableTurnNumber;
  }

  public set NextAvailableTurnNumber(value: string) {
    this.nextAvailableTurnNumber = value;
  }

  public get Locations(): LocationDesk[] {
    return this.locations;
  }

  public set Locations(locations: LocationDesk[]) {
    this.locations = locations;
  }
}
